module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-sad-face-smiley-2-svgrepo-com.bcfe8587.svg";